import React from 'react';
import { CustomColumn, StringColumn } from 'baseui/data-table';
import Label from 'commons-ui/src/components/baseui/input/Label';
import { EMPTY_STRING } from 'commons-ui';
import _get from 'lodash/get';
import dayjs from 'dayjs';
import { IListConfigParams, IPermission } from 'models/settingsV2.model';

export const COL_NAMES = {
	permissionName: 'resourceName',
	permissionDesc: 'description',
	action: 'actionName',
	updatedAt: 'updatedAt',
	updatedBy: 'updatedBy'
};
export const columnConfigs = [
	StringColumn({
		title: 'Permission Name',
		maxWidth: 300,
		mapDataToValue: (data: IPermission) => {
			return String(_get(data, COL_NAMES.permissionName, EMPTY_STRING));
		}
	}),
	CustomColumn({
		title: 'Permission Description',
		maxWidth: 300,
		mapDataToValue: (data: IPermission) => {
			return {
				desc: String(_get(data, COL_NAMES.permissionDesc, EMPTY_STRING))
			};
		},
		renderCell: (params: IListConfigParams) => {
			const { value } = params;
			const truncatedDesc: string =
				value?.desc.split(' ').slice(0, 5).join(' ') + (value.desc.split(' ').length > 5 ? '...' : '');
			return (
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-start',
						alignItems: 'center',
						width: '100%',
						height: '100%',
						textAlign: 'left'
					}}>
					<Label label={truncatedDesc} toolTip={value.desc} />
				</div>
			);
		}
	}),
	StringColumn({
		title: 'Permission Action',
		mapDataToValue: (data: IPermission) => {
			return String(_get(data, COL_NAMES.action, EMPTY_STRING));
		}
	}),
	StringColumn({
		title: 'Updated At',
		mapDataToValue: (data: IPermission) => {
			return dayjs(new Date(_get(data, COL_NAMES.updatedAt, EMPTY_STRING))).format('DD-MM-YYYY hh:mm A') || EMPTY_STRING;
		}
	}),
	StringColumn({
		title: 'Updated By',
		mapDataToValue: (data: IPermission) => {
			return String(_get(data, COL_NAMES.updatedBy, EMPTY_STRING));
		}
	})
];

export default { columnConfigs, COL_NAMES };
